<script lang="ts">
    import dayjs from 'dayjs'
    import customParseFormat from 'dayjs/plugin/customParseFormat.js'
    dayjs.extend(customParseFormat)
    import { onMount, tick } from 'svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { AllowedHoursEntity, AllowedHoursIntervalEntity } from '../../../modules/usersApi/companies/company'
    import Zbutton from '../../_common/z/zbutton.svelte'

    let allowedHours: AllowedHoursEntity = null
    let days = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']

    async function load() {
        const allow = await window.api.users.companies.getAllowLogin(window.store.token.userId)
        allowedHours = new AllowedHoursEntity()
        allowedHours.interval = allow.allowedHours?.interval
    }

    function getTime(day: AllowedHoursIntervalEntity) {
        if (day.fromTime === day.toTime) return 'Não permitido'
        const fromTime = dayjs().startOf('day').add(day.fromTime, 'minute').format('HH:mm')
        const toTime = dayjs().startOf('day').add(day.toTime, 'minute').format('HH:mm')
        return fromTime + ' até ' + toTime
    }

    let show = false

    onMount(async () => {
        await load()
    })

    async function goLogout() {
        await window.api.users.auth.logout(false)
        location.href = '/login'
    }
</script>

<div class="root-ur">
    <LoadSpinner {show}></LoadSpinner>
    {#if allowedHours}
        <Content>
            <div class="p-5">
                <Zframe>
                    <div class="text-center">
                        <div class="">Neste horário seu acesso está desabilitado.</div>
                        <div class="text-muted mt-3">
                            <div class="-day mb-1">Horários com acesso autorizado:</div>
                            {#each allowedHours.interval as day, index}
                                <div class="-day -day-bold--{new Date().getDay() === day.weekDay}">
                                    <div class="-label">{days[day.weekDay]}:</div>
                                    <div class="-hour">{getTime(day)}</div>
                                </div>
                            {/each}
                        </div>
                        <div class="-acts">
                            <Zbutton grow={true} label="Atualizar tela" on:click={() => location.reload()}></Zbutton>
                            <Zbutton grow={true} label="Fazer logoff" on:click={goLogout}></Zbutton>
                        </div>
                    </div>
                </Zframe>
            </div>
        </Content>
    {/if}
</div>

<style>
    .root-ur {
        background-color: #333;
        color: #eee;
        height: 100vh;
    }
    .-day {
        display: flex;
        justify-content: center;
    }
    .-day > * {
        flex: 0 0 150px;
    }
    .-day .-label {
        text-align: right;
        padding-right: 8px;
    }
    .-day .-hour {
        text-align: left;
    }
    .root-ur .-acts {
        display: flex;
        justify-content: center;
        gap: 8px;
        flex-wrap: wrap;
        padding-top: 16px;
    }
    :global(.root-ur .-acts > *) {
        max-width: 240px;
    }
    .-day-bold--true {
        color: salmon;
    }
</style>
